import gql from 'graphql-tag';

import { ReviewFragment } from 'bundles/reviews-common/components/Review';

export const COURSE_REVIEW_QUERY = gql`
  query AllCourseReviews(
    $courseId: String!
    $limit: Int!
    $start: String!
    $ratingValues: [Int!]
    $productCompleted: Boolean
    $sortByHelpfulVotes: Boolean!
  ) {
    ProductReviewsV1Resource {
      reviews: byProduct(
        productId: $courseId
        ratingValues: $ratingValues
        limit: $limit
        start: $start
        productCompleted: $productCompleted
        sortByHelpfulVotes: $sortByHelpfulVotes
      ) {
        elements {
          ...ReviewFragment
        }
        paging {
          total
        }
      }
    }
  }
  ${ReviewFragment}
`;

export default COURSE_REVIEW_QUERY;
